




































































































































































import BackButton from "@/components/BackButton.vue";
import { Vue, Component, Watch } from "vue-property-decorator";
import { statisticService } from "@/services/statistic.service";

import { Resources } from "@/shared/resources";
import LineChart from "@/components/Charts/LineChart.vue";
import DataTable from "@/components/DataTable.vue";
import { jobService } from "../../services/job.service";
import { ChartData } from "@/models/chart.model";
import { JobStatisticSummary } from "@/models/job.model";
import utils from "@/common/utils";
import { cardService } from "../../services/card.service";
import { saveAs } from "file-saver";

@Component({
    components: {
        BackButton,
        LineChart,
        DataTable
    }
})
export default class AdminStatitic extends Vue {
    chartDataCollection: ChartData[] = [];
    dateInterval: any = Resources.dateInterval;
    jobStatus: any = Resources.jobStatus;
    selectedDateInterval: any = 4; // dag
    // selectedJobId:number|null = null;

    jobStatisticSummary: JobStatisticSummary = {};
    jobStatisticList: any = [];
    jobKeyValueList: any = [];
    cardKeyValueList: any = [];
    selectedJob: any = [];
    selectedCard: any = [];
    dateConverter = utils;

    @Watch("selectedDateInterval")
    async selectedPeriodChanged() {
        await this.initChartStats();
    }

    @Watch("selectedCard")
    async selectedCardChanged() {
        this.selectedJob = [];
        await this.poplulateJobs();
        await this.initChartStats();
        await this.initJobStat();
    }

    @Watch("selectedJob")
    async selectedJobChanged() {
        await this.initChartStats();
        await this.initJobStat();
    }

    fromDate: Date = new Date();
    toDate: Date = new Date();

    async fromDateChanged(date: Date) {
        // this.fromDate = date;
        await this.initChartStats(new Date(date), undefined);
        await this.initJobStat();
    }

    async toDateChanged(date: Date) {
        // this.toDate = date;
        await this.initChartStats(undefined, new Date(date));
        await this.initJobStat();
    }

    async poplulateJobs() {
        this.jobKeyValueList = await jobService.getAllKeyValue(
            this.$store.getters["app/companyId"],
            this.selectedCard ? this.selectedCard.key : undefined
        );
    }

    async popluateCards() {
        this.cardKeyValueList = await cardService.getAllKeyValue();
    }

    async created() {
        let classStat = await statisticService.getStatisticsInformationOnClass(
            "JobEvent"
        );

        await this.poplulateJobs();
        await this.popluateCards();

        this.fromDate = new Date(classStat.minDate);
        this.toDate = new Date(classStat.maxDate);

        await this.initJobStat();
    }

    async getJobStatExcel() {
        let result = await statisticService.getJobStatisticListFile({
            fromDate: this.fromDate,
            toDate: this.toDate,
            jobId: this.selectedJob ? this.selectedJob.key : null,
            cardId: this.selectedCard ? this.selectedCard.key : null
        });

        saveAs(result, "statistik.xlsx");
    }

    async initJobStat(
        fromDate: Date = this.fromDate,
        toDate: Date = this.toDate
    ) {
        this.jobStatisticSummary = await statisticService.getJobSummaryStatistic(
            {
                fromDate: fromDate,
                toDate: toDate,
                jobId: this.selectedJob ? this.selectedJob.key : null,
                cardId: this.selectedCard ? this.selectedCard.key : null
            }
        );

        this.jobStatisticList = await statisticService.getJobStatisticList({
            fromDate: fromDate,
            toDate: toDate,
            jobId: this.selectedJob ? this.selectedJob.key : null,
            cardId: this.selectedCard ? this.selectedCard.key : null
        });

        console.log(this.jobStatisticList);

        

        this.jobStatisticList.map((stat: any) => {
            (stat.status = this.jobStatus.find((j:any) => j.key == stat.status).text),
                (stat.date = this.dateConverter.convertToReaderFriendlyDate(
                    stat.date
                ));
        });

        // @ts-ignore
        this.$refs.dataTable.renderTable(this.jobStatisticList);
    }

    async initChartStats(
        fromDate: Date = this.fromDate,
        toDate: Date = this.toDate
    ) {
        this.chartDataCollection = [];
        let done = await statisticService.getAssignedJobsChartDataStatistics({
            companyId: this.$store.getters["app/companyId"],
            fromDate: fromDate,
            toDate: toDate,
            jobEventStatus: 2,
            dateInterval: this.selectedDateInterval,
            jobId: this.selectedJob ? this.selectedJob.key : null,
            cardId: this.selectedCard ? this.selectedCard.key : null
        });

        let assigned = await statisticService.getAssignedJobsChartDataStatistics(
            {
                companyId: this.$store.getters["app/companyId"],
                fromDate: fromDate,
                toDate: toDate,
                jobEventStatus: 1,
                dateInterval: this.selectedDateInterval,
                jobId: this.selectedJob ? this.selectedJob.key : null,
                cardId: this.selectedCard ? this.selectedCard.key : null
            }
        );

        let moved = await statisticService.getAssignedJobsChartDataStatistics({
            companyId: this.$store.getters["app/companyId"],
            fromDate: fromDate,
            toDate: toDate,
            jobEventStatus: 3,
            dateInterval: this.selectedDateInterval,
            jobId: this.selectedJob ? this.selectedJob.key : null,
            cardId: this.selectedCard ? this.selectedCard.key : null
        });

        this.chartDataCollection.push({
            data: utils.mapToChartData(done),
            title: "Gjorda"
        } as ChartData);
        this.chartDataCollection.push({
            data: utils.mapToChartData(assigned),
            title: "Tilldelade"
        } as ChartData);
        this.chartDataCollection.push({
            data: utils.mapToChartData(moved),
            title: "Flyttade"
        } as ChartData);

        // @ts-ignore
        this.$refs.lineChart.render(this.chartDataCollection);
        this.chartDataCollection = [];
    }
}
